import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  withCredentials: true,
  timeout: 10000, // 10 seconds timeout
});

// Add token to requests if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Handle responses and errors with retry logic
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Handle rate limiting errors (429)
    if (error.response?.status === 429) {
      const retryAfter = error.response.headers['retry-after'] || 60;
      
      console.warn(`Rate limit exceeded. Retrying after ${retryAfter} seconds...`);
      
      // If this is the first retry attempt
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        
        // Wait for the specified time before retrying (max 60 seconds)
        const waitTime = Math.min(retryAfter * 1000, 60000);
        await new Promise(resolve => setTimeout(resolve, waitTime));
        
        return api(originalRequest);
      }
    }

    // Handle authentication errors (401)
    if (error.response?.status === 401) {
      // Token is expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Redirect to login page if not already there
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

// WhatsApp API functions
export const whatsappApi = {
  // Get session status
  getSessionStatus: () => api.get('/whatsapp/session/status'),
  
  // Start WhatsApp session
  startSession: (forceReset: boolean = false) => api.post('/whatsapp/session/start', { forceReset }),
  
  // Stop WhatsApp session
  stopSession: () => api.post('/whatsapp/session/stop'),
  
  // Get current QR code
  getQRCode: () => api.get('/whatsapp/session/qr'),
  
  // Force reset session when max QR generations are reached
  resetSession: () => api.post('/whatsapp/session/reset'),
  
  // Legacy status endpoint
  getStatus: () => api.get('/whatsapp/status'),
};

export default api; 